<input
  class="percentage-input"
  type="text"
  inputmode="decimal"
  autocomplete="off"
  [attr.id]="controlId"
  [maskito]="mask"
  [value]="value"
  [disabled]="disabled"
  [placeholder]="placeholder"
  [class.form-error-border]="error"
  (input)="handleInput($event)"
  (focus)="handleFocus($event)"
  (blur)="handleBlur()" />
